/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect } from 'react';
import mbpUtil from 'mbp-api-util';
import { usePazeContext } from './PazeContext';

const PazePaymentScript = () => {
    const { setScriptLoaded } = usePazeContext();

    useEffect(() => {
        const src = mbpUtil.getEnv('APP_PAZE_SDK_URL');
        if (setScriptLoaded) {
            if (typeof window !== 'undefined' && !document.querySelector('#paze-payment-script') && src) {
                const script = document.createElement('script');
                script.id = 'paze-payment-script';
                script.async = true;
                script.onload = () => setScriptLoaded(true);
                script.src = src;
                document.body.appendChild(script);
            } else {
                setScriptLoaded(true);
            }
        }
    }, []);

    return null;
};

export default PazePaymentScript;
